import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" };
const _hoisted_2 = { class: "text-lg font-semibold text-eblack-900" };
const _hoisted_3 = { class: "mt-1 text-sm text-eblack-600" };
const _hoisted_4 = { class: "rounded-lg bg-eorange-50 p-3 text-sm text-eorange-800" };
const _hoisted_5 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_6 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_7 = {
    key: 0,
    class: "text-sm text-red-500"
};
const _hoisted_8 = {
    key: 1,
    class: "text-sm text-red-500"
};
const _hoisted_9 = { class: "flex justify-end gap-2" };
const _hoisted_10 = ["disabled"];
const _hoisted_11 = ["disabled"];
import { computed, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PasswordResetModal',
    props: {
        title: {},
        userLabel: {},
        helpText: {},
        newPasswordLabel: {},
        confirmPasswordLabel: {},
        submitText: {},
        submittingText: {},
        cancelText: {},
        minLengthText: {},
        mismatchText: {},
        isSubmitting: { type: Boolean },
        error: {}
    },
    emits: ["submit", "cancel"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const newPassword = ref("");
        const confirmPassword = ref("");
        const attemptedSubmit = ref(false);
        const validationError = computed(() => {
            if (!attemptedSubmit.value)
                return "";
            if (newPassword.value.length < 8)
                return props.minLengthText;
            if (newPassword.value !== confirmPassword.value)
                return props.mismatchText;
            return "";
        });
        function submit() {
            attemptedSubmit.value = true;
            if (validationError.value)
                return;
            emit("submit", newPassword.value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("form", {
                        class: "flex w-full max-w-md flex-col gap-4 rounded-xl bg-white p-6 shadow-2xl",
                        onSubmit: _withModifiers(submit, ["prevent"])
                    }, [
                        _createElementVNode("div", null, [
                            _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
                            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.userLabel), 1)
                        ]),
                        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.helpText), 1),
                        _createElementVNode("label", _hoisted_5, [
                            _createTextVNode(_toDisplayString(__props.newPasswordLabel) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((newPassword).value = $event)),
                                type: "password",
                                class: "rounded-md border-ewhite-300 text-sm focus:ring-blue-400",
                                autocomplete: "new-password"
                            }, null, 512), [
                                [_vModelText, newPassword.value]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_6, [
                            _createTextVNode(_toDisplayString(__props.confirmPasswordLabel) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((confirmPassword).value = $event)),
                                type: "password",
                                class: "rounded-md border-ewhite-300 text-sm focus:ring-blue-400",
                                autocomplete: "new-password"
                            }, null, 512), [
                                [_vModelText, confirmPassword.value]
                            ])
                        ]),
                        (validationError.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(validationError.value), 1))
                            : (__props.error)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.error), 1))
                                : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "rounded-lg border border-ewhite-300 px-4 py-2 text-sm text-eblack-700",
                                disabled: __props.isSubmitting,
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('cancel')))
                            }, _toDisplayString(__props.cancelText), 9, _hoisted_10),
                            _createElementVNode("button", {
                                type: "submit",
                                class: "rounded-lg bg-eblack-900 px-4 py-2 text-sm text-white disabled:opacity-60",
                                disabled: __props.isSubmitting
                            }, _toDisplayString(__props.isSubmitting ? __props.submittingText : __props.submitText), 9, _hoisted_11)
                        ])
                    ], 32)
                ])
            ]));
        };
    }
});
